import * as React from 'react';
import { Create, SimpleForm, TextInput, required, maxLength, Toolbar, SaveButton, useNotify, useRedirect } from 'react-admin';
import { Button } from '@mui/material';
import useAdmin from '../hooks/useAdmin';

const CustomToolbar = () => {
    const redirect = useRedirect();

    const handleBack = () => {
        redirect('/directorycategories');
    };

    return (
        <Toolbar>
            <SaveButton />
            <Button color="primary" onClick={handleBack} style={{ marginLeft: '10px' }}>Back</Button>
        </Toolbar>
    );
};

export const DirectoryCategoryCreate = (props: any) => {
    const notify = useNotify();
    const redirect = useRedirect();

    const onSuccess = () => {
        notify('resources.directorycategories.notification.created', {
            type: 'info',
            messageArgs: { smart_count: 1, name: 'Directory Category' }
        });
        redirect('/directorycategories');
    };
    useAdmin();
    return (
        <Create {...props} mutationOptions={{ onSuccess: onSuccess }}>
            <SimpleForm toolbar={<CustomToolbar />}>
                <TextInput source="category_name" label="Name" validate={[required(), maxLength(50)]} />
                <TextInput source="category_description" label="Description" validate={maxLength(200)} />
            </SimpleForm>
        </Create>
    );
};

export default DirectoryCategoryCreate;
